import { canonicalUrlForPath } from './routeMeta.js'

function ensureMetaByProperty(property, content) {
  let el = document.querySelector(`meta[property="${property}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('property', property)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function ensureMetaByName(name, content) {
  let el = document.querySelector(`meta[name="${name}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute('name', name)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function ensureLinkCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

/**
 * Updates document title and social meta tags for the current route.
 * Crawlers that execute JavaScript (many social previews) will see these after hydration.
 *
 * @param {import('./routeMeta.js').SeoPayload} seo
 */
export function applyDocumentSeo(seo) {
  const url = canonicalUrlForPath(seo.path)
  const image = seo.image
  const imageAlt = seo.imageAlt ?? ''

  document.title = seo.title

  ensureMetaByName('description', seo.description)
  ensureLinkCanonical(url)

  ensureMetaByProperty('og:type', 'website')
  ensureMetaByProperty('og:url', url)
  ensureMetaByProperty('og:title', seo.title)
  ensureMetaByProperty('og:description', seo.description)
  ensureMetaByProperty('og:image', image)
  ensureMetaByProperty('og:image:alt', imageAlt)
  ensureMetaByProperty('og:site_name', 'Akara')
  ensureMetaByProperty('og:locale', 'en_AE')

  const card = seo.twitterCard ?? 'summary_large_image'
  ensureMetaByName('twitter:card', card)
  ensureMetaByName('twitter:title', seo.title)
  ensureMetaByName('twitter:description', seo.description)
  ensureMetaByName('twitter:image', image)
  ensureMetaByName('twitter:site', '@akara_ae')
}
